export default __webpack_public_path__ + "static/media/matic.0ed8507d.png";